/**
 * Format the supplier products and recipes, from what's displayed in the DataGrid
 * into appropriate payloads for calling the API
 *
 * @param {Array} supplierProducts - The supplier products displayed in the DataGrid
 * @param {Array} recipes - The recipes displayed in the DataGrid
 * @returns {Object} - The formatted supplier products and recipes
 */
export const formatSPAndRecipesPayloadForCreation = (supplierProducts, recipes) => {
  const supplierProductsPayload = supplierProducts
    .filter(({ packagings }) => packagings.some(({ selectedQuantity }) => selectedQuantity > 0))
    .map(({ id, packagings }) => ({
      id,
      quantityByPackagingId: packagings.reduce((acc, { id, selectedQuantity }) => {
        acc[id] = selectedQuantity;
        return acc;
      }, {}),
    }));

  const recipesPayload = recipes
    .filter(({ selectedQuantity }) => selectedQuantity > 0)
    .map(({ id, selectedQuantity }) => ({
      id,
      quantity: selectedQuantity,
    }));

  return {
    supplierProducts: supplierProductsPayload,
    recipes: recipesPayload,
  };
};

export const formatSPAndRecipesPayloadForDeliveryNote = (supplierProducts, recipes) => {
  const supplierProductsPayload = supplierProducts.map(({ id, packagings }) => ({
    supplierProductId: id,
    packagings: packagings.map(({ id, transferId, selectedQuantity }) => ({
      id,
      transferId,
      quantity: selectedQuantity,
    })),
  }));

  const recipesPayload = recipes.map(({ transferId, id, selectedQuantity }) => ({
    entityId: id,
    transferId,
    quantity: selectedQuantity,
  }));

  return {
    supplierProducts: supplierProductsPayload,
    recipes: recipesPayload,
  };
};
